import NotificationBox from './NotificationBox';

export default NotificationBox;
